module.exports = __webpack_public_path__ + "static/media/typescript.41a45a54.png";